import { visuallyHidden } from './visually-hidden.css';

export const VisuallyHidden: React.FC<React.PropsWithChildren> = (props) => (
  <span className={visuallyHidden} {...props} />
);
